export enum EVerificationCodeTypes {
  Authenticate = 'authenticate',
  UpdateEmail = 'update_email',
  VerifyEmail = 'verify_email',
  ProfileDelete = 'profile_delete',
}
